<div id="gjs"></div>

<div class="bottom-affex">
  <nz-space>
    <nz-space-item
      ><button nz-button nzType="primary" (click)="onSaveContent()">
        <nz-space>
          <nz-space-item><i class="fal fa-plus-circle"></i></nz-space-item>
          <nz-space-item> Save </nz-space-item>
        </nz-space>
      </button></nz-space-item
    >
    <nz-space-item
      ><button nz-button nzType="default" (click)="ClearContent()">
        <nz-space>
          <nz-space-item><i class="fal fa-file-times"></i></nz-space-item>
          <nz-space-item> Clear </nz-space-item>
        </nz-space>
      </button></nz-space-item
    >
  </nz-space>
</div>
